import { FC } from 'react';
import { useRouter } from 'next/router';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import { FeedbackTypes } from '@web-kc/core/api';

interface Props {
  topic: FeedbackTypes['TopicDto'];
  activeTopic?: string;
  setActiveTopic: (topic?: string) => void;
}

export const ReferenceSidebarItem: FC<Props> = ({
  topic,
  activeTopic,
  setActiveTopic,
}) => {
  const router = useRouter();
  const isActive = activeTopic === topic.id;

  const handleTopicClick = () => {
    setActiveTopic(topic.id);
    router.push(
      {
        pathname: '/reference',
        query: { topic: topic.id },
      },
      undefined,
      { shallow: true, scroll: false },
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ListItem disablePadding>
      <ListItemButton sx={{ padding: '4px 5px' }} onClick={handleTopicClick}>
        <Box
          sx={{
            padding: '4px 10px',
            backgroundColor: isActive ? '#FFFFFF' : 'transparent',
            borderRadius: isActive ? '14px' : '0px',
          }}
        >
          <Typography
            fontSize={16}
            color={isActive ? 'primary' : 'text.primary'}
            lineHeight="20px"
            whiteSpace="pre-line"
          >
            {topic.name}
          </Typography>
        </Box>
      </ListItemButton>
    </ListItem>
  );
};

export default ReferenceSidebarItem;
